// src/stats/domain/services/matchStatsUiService.ts

import type { ParameterCode } from "~/src/stats/domain/models/Parameter";

export const $MATCH_TEAM_STATS: ParameterCode[] = [
  //"GOL-ALL",
  "GOL-SHO",
  "GOL-R",
  "GOL-2X",
  // "GOL-NO-WEAPON",
  "XG",
  "TIR",
  "TIR-S",
  "TIR-W",
  "CRN",
  "FRG",
  "PAS-X",
  "PSP-X",
  "FAL",
  "CRT-G",
  "CRT-R",
  //"ASS-V",
  //"RIG",
  //"SHO",
]; // TODO - "ARMA", "DICE"

export const $MATCH_PLAYER_STATS: ParameterCode[] = [
  "GOL",
  "GOL-2X",
  "GOL-SHO-REG",
  "GOL-R-ALL",
  "GOL-DICE",
  "TIR",
  "TIR-S",
  "TIR-W",
  "ASS-V",
  "CRT-G",
  "CRT-R",
  "DRB-R",
  "DRB",
  "FAL",
  "GOL-A",
  "RIG",
  "RIG-F",
  "SHO",
  "SHO-F",
  //"XG",
  "FRG",
];

export const $PAGE_PLAYER_STATS: ParameterCode[] = [
  "GOL-ALL",
  "GOL",
  "GOL-2X",
  "GOL-SHO-REG",
  "GOL-R-ALL",
  "GOL-DICE",
  "TIR",
  "TIR-S",
  "TIR-W",
  "ASS-V",
  "CRT-G",
  "CRT-R",
  "DRB-R",
  "DRB",
  "FAL",
  "GOL-A",
  "RIG-ALL",
  "RIG-F-ALL",
  "SHO",
  "SHO-F",
  "SHO-PRES",
  "SHO-F-PRES",
  //"XG",
  "FRG",
];

export const $MATCH_GK_PLAYER_STATS: ParameterCode[] = [
  "PRT",
  "RIG-P",
  "SHO-P",
  "GOL-S",
  "TIR",
  "TIR-S",
  "TIR-W",
  "ASS-V",
  "CRT-G",
  "CRT-R",
  "DRB-R",
  "DRB",
  "FAL",
  "GOL-A",
  "RIG",
  "RIG-F",
  "SHO",
  "SHO-F",
  //"XG",
  "FRG",
  "GOL-ALL",
  "GOL",
  "GOL-2X",
  "GOL-SHO-REG",
  "GOL-R-ALL",
  "GOL-DICE",

  /*  "TIR",
  "TIR-S",
  "CRT-G",
  "CRT-R",
  "FAL",
  "ASS-V",
  "FRG",
  "DRB",
  "GOL-ALL",
  "PRT",
  "GOL-A",
  "MVP",*/
];

export const $PAGE_GK_PLAYER_STATS: ParameterCode[] = [
  "PRT",
  "RIG-P",
  "SHO-P",
  "GOL-ALLS",
  "GOL-S",
  "TIR",
  "TIR-S",
  "TIR-W",
  "ASS-V",
  "CRT-G",
  "CRT-R",
  "DRB-R",
  "DRB",
  "FAL",
  "GOL-A",
  "RIG-ALL",
  "RIG-F-ALL",
  "SHO",
  "SHO-F",
  "SHO-PRES",
  "SHO-F-PRES",
  //"XG",
  "FRG",
  "GOL-ALL",
  "GOL",
  "GOL-2X",
  "GOL-SHO-REG",
  "GOL-R-ALL",
  "GOL-DICE",

  /*  "TIR",
  "TIR-S",
  "CRT-G",
  "CRT-R",
  "FAL",
  "ASS-V",
  "FRG",
  "DRB",
  "GOL-ALL",
  "PRT",
  "GOL-A",
  "MVP",*/
];
